module.exports = "<footer class=\"footer\">\n<p></p>\n</footer>"